import { endOfDay, subDays, subMonths, subYears } from 'date-fns';

function getDateRange(values, idx) {
  let now = new Date(),
    newRange = {};

  switch (idx) {
    case 0:
      newRange = {
        range: [now, endOfDay(subDays(now, 7))],
        filter: 'Week'
      };
      break;

    case 1:
      newRange = {
        range: [now, endOfDay(subMonths(now, 1))],
        filter: 'Month'
      };
      break;

    case 2:
      newRange = {
        range: [now, endOfDay(subYears(now, 1))],
        filter: 'Year'
      };
      break;

    case 3:
      newRange = {
        range: null,
        filter: 'All',
        all: true
      };
      break;

    default:
      newRange = {
        range: values.sort((a, b) => new Date(b) - new Date(a)),
        filter: 'Custom...'
      };
  }

  return newRange;
}

export default getDateRange;
